<template>
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="imgBoxUrl" class="el-image__inner">
      </div>
    </div>
    <div class="contentBox">
      <div class="item_body">
        <div class="item_tital">
    {{item.tital}}
        </div>

        <div class="item_date">
{{item.date}}
        </div>
        <el-divider></el-divider>
        <div class="item_count">
{{item.count}}
        </div>
        <div class="item_image">
          <div class="item_image_1">
            <el-image
              style="width: 578px; height: 340px"
              :src="item.img.img1"
              :fit="contain"></el-image>
          </div>
          <div class="item_image_1">
            <el-image
              style="width: 578px; height: 340px"
              :src="item.img.img2"
              :fit="contain"></el-image>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "newsItem",
  data() {
    return {
      imgBoxUrl:"http://116.62.38.250//image/sy/lben.jpg",
      urlData:"",
      item:{
        tital:"Er:YAG Laser Treatment System’s First Appearance in 2024 Concludes Successfully!",
        date:"March 19, 2024, Afternoon",
        count:"Micro-Innovation, a high-tech enterprise dedicated to developing advanced dental laser treatment devices with over 50 patents, made a remarkable debut of its third-generation Er:YAG Dental Laser Treatment System at the South China Dental Exhibition. The event attracted a large number of dental professionals and distributors who eagerly inquired and experienced the product firsthand. With cutting-edge technology, Micro-Innovation earned high praise from industry experts, showcasing its strong capabilities in the field of dental laser treatment.\n" +
          "The Er:YAG Dental Laser Treatment System, equipped with military-grade Er:YAG crystals, generates a 2940nm laser wavelength. Using dynamic focusing technology within the handpiece, it interacts with water molecules in oral tissues, creating a \"micro-explosion\" effect. This enables the vaporization, ablation, and cutting of both soft and hard tissues in the oral cavity. The laser’s impact on the surface temperature of tissues is minimal, making it one of the most efficient and safest treatment methods in the dental laser field today. It has wide applications across various dental disciplines, particularly excelling in periodontics, implantology, orthodontics, aesthetics, and pediatric dentistry.\n" +
          "Micro-Innovation’s outstanding performance at the South China Dental Exhibition not only highlighted the brand's strength but also symbolized the limitless possibilities in the future of healthcare. The company remains committed to its mission: \"To provide patients with fear-free dental care and to help doctors treat teeth safely and efficiently.\" Micro-Innovation continues to develop advanced, high-end dental equipment with the goal of becoming a global leader in dental laser products.\n" +
          "Reflecting on the exhibition, numerous visitors expressed keen interest in the system’s unique technology and notable clinical outcomes. Micro-Innovation staff warmly welcomed every visitor, patiently answering questions and providing live product demonstrations. Visitors had the chance to experience the real effects of the Er:YAG Laser Treatment System in action and were captivated by the laser＇s potential.\n" +
          "Many visitors, impressed by the product's performance, software capabilities, and customer service, engaged in enthusiastic discussions and expressed strong interest in collaboration.\n" +
          "As the vibrant spring season brings new energy, the 29th South China International Dental Exhibition has come to a close. Micro-Innovation sincerely thanks all who showed interest and support for the Er:YAG Dental Laser Treatment System. We look forward to reuniting soon at future events to continue shaping the bright future of dental laser technology together!",
        img:{
          img1:"http://116.62.38.250//image/nr/news/item11.png",
          img2:"http://116.62.38.250//image/nr/news/item12.jpg"
        }
      },
      newList:[
        {
          index:'gss',
          item:{
            tital:"Er:YAG Laser Treatment System’s First Appearance in 2024 Concludes Successfully!",
            date:"March 19, 2024, Afternoon",
            count:"Micro-Innovation, a high-tech enterprise dedicated to developing advanced dental laser treatment devices with over 50 patents, made a remarkable debut of its third-generation Er:YAG Dental Laser Treatment System at the South China Dental Exhibition. The event attracted a large number of dental professionals and distributors who eagerly inquired and experienced the product firsthand. With cutting-edge technology, Micro-Innovation earned high praise from industry experts, showcasing its strong capabilities in the field of dental laser treatment.\n" +
              "The Er:YAG Dental Laser Treatment System, equipped with military-grade Er:YAG crystals, generates a 2940nm laser wavelength. Using dynamic focusing technology within the handpiece, it interacts with water molecules in oral tissues, creating a \"micro-explosion\" effect. This enables the vaporization, ablation, and cutting of both soft and hard tissues in the oral cavity. The laser’s impact on the surface temperature of tissues is minimal, making it one of the most efficient and safest treatment methods in the dental laser field today. It has wide applications across various dental disciplines, particularly excelling in periodontics, implantology, orthodontics, aesthetics, and pediatric dentistry.\n" +
              "Micro-Innovation’s outstanding performance at the South China Dental Exhibition not only highlighted the brand's strength but also symbolized the limitless possibilities in the future of healthcare. The company remains committed to its mission: \"To provide patients with fear-free dental care and to help doctors treat teeth safely and efficiently.\" Micro-Innovation continues to develop advanced, high-end dental equipment with the goal of becoming a global leader in dental laser products.\n" +
              "Reflecting on the exhibition, numerous visitors expressed keen interest in the system’s unique technology and notable clinical outcomes. Micro-Innovation staff warmly welcomed every visitor, patiently answering questions and providing live product demonstrations. Visitors had the chance to experience the real effects of the Er:YAG Laser Treatment System in action and were captivated by the laser＇s potential.\n" +
              "Many visitors, impressed by the product's performance, software capabilities, and customer service, engaged in enthusiastic discussions and expressed strong interest in collaboration.\n" +
              "As the vibrant spring season brings new energy, the 29th South China International Dental Exhibition has come to a close. Micro-Innovation sincerely thanks all who showed interest and support for the Er:YAG Dental Laser Treatment System. We look forward to reuniting soon at future events to continue shaping the bright future of dental laser technology together!",
            img:{
              img1:"http://116.62.38.250//image/nr/news/item11.png",
              img2:"http://116.62.38.250//image/nr/news/item12.jpg"
            }
          }
        },
        {
          index:'gxx',
          item:{
            tital:"The Grand Opening of the 2024 Northeast International Dental Exhibition - Micro-Innovation Invites You to Shenyang!",
            date:"March 20, 2024, Afternoon",
            count:
              "2024 Northeast International Dental Exhibition PART ONE INVITATION\n" +
              "The 25th China Northeast International Dental Equipment Exhibition and Academic Conference will take place from March 22-25, 2024, at the Shenyang New World Expo. Since its inception in 1999, the Northeast International Dental Exhibition (CNDE) has grown to cover an exhibition area of 24,000 square meters, featuring 575 participating companies. It has become one of the most important professional events in China's dental industry, ranking as the fourth-largest dental exhibition in China after Beijing, Shanghai, and Guangzhou.\n" +
              "Micro-Innovation will make a spectacular appearance at the exhibition, showcasing the latest Er:YAG Dental Laser Treatment System. We look forward to meeting you at the event and exploring new chapters in the field of comfort-oriented laser treatments.\n" +
              "Micro-Innovation warmly invites you to visit our booth to learn more about the minimally invasive, comfort-focused solutions offered by our Er:YAG laser technology. Let’s witness the future of laser technology together!",
            img:{
              img1:"http://116.62.38.250/image/nr/news/item21.jpg",
              img2:"http://116.62.38.250/image/nr/news/item22.jpg"
            }
          }
        },
        {
          index:'gyy',
          item:{
            tital:"Micro-Innovation | March in Zhengzhou Awaits You!",
            date:"March 27, 2024, Afternoon",
            count:"The 2024 China Central (Zhengzhou) Dental Equipment and Materials Exhibition & Dental Medicine Academic Conference will be held from March 28-30, 2024, at the Zhengzhou International Convention and Exhibition Center. This professional event is based in Henan and extends its influence throughout central China and beyond, serving both as a specialized dental exhibition and academic conference.\n" +
              "Micro-Innovation will showcase its third-generation Er:YAG Dental Laser Treatment System, offering a spectacular presentation of cutting-edge technology. We eagerly await the opportunity to meet you at the exhibition and embark on a new chapter in the laser treatment field, bringing even more possibilities for comfort-focused care.\n" +
              "With our dedication and your support, we believe that laser treatment will achieve even greater advancements. Let’s stand together and create a bright future for the dental laser industry!\n" +
              "March 28-30 in Zhengzhou\n" +
              "Look forward to Micro-Innovation’s extraordinary exhibition.\n" +
              "We sincerely invite you to join us as we witness the new future of laser technology under the name of Micro-Innovation.",
            img:{
              img1:"http://116.62.38.250//image/nr/news/item31.png",
              img2:"http://116.62.38.250//image/nr/news/item32.png"
            }
          }
        }
      ]
    }
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.index;
  },
  mounted() {
    let  that = this;
    that.init();
  },
  methods: {
    init(){
      let  that = this;

      if(that.urlData != "" && that.urlData !=undefined){
        // console.log(11)
        for ( let itemNE in that.newList){
          let itemData = that.newList[itemNE]
          console.log(itemData)
          // console.log(itemNE.index)
          if(that.urlData == itemData.index){
            that.item = itemData.item;
            break;
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.item_image_1{
  margin: 10px;
}
.item_image{
  display: flex;
  margin-top: 30px;
}
.item_count{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
  line-height: 32px;
  margin-top: 20px;
  white-space: pre-wrap;
}
.item_date{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #999999;
  text-align: justify;
  margin-top: 20px;
  margin-bottom: 20px;
}
.item_tital{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
  margin-top: 20px;
}
.contentBox {
  width: 1176px;
  margin: 50px auto;
}
.productPage {
  display: block;
  width: 1920px;
  background-color: #FFFFFF;
}
.imgBox {
  width: 100%;
  height: 600px;
}

.imageItem {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/en/newsItem.vue